import React, {useState, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import clientService from '../../services/ClientService';
import "../../static/css/slide.css";

export default function SlideActionClient({show,onClose,onFetchClients,search,client}) {
    const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm({
        defaultValues: {
            status: "true",
        },
    });
    const [message, setMessage] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const closeSlide = () => {
        setErrorMsg("");
        setMessage("");
        onClose();
    };
    const normalizeData = (data) => {
        return Object.keys(data).reduce((acc, key) => {
            let value = data[key];

            if (typeof value === "string") {
                value = value.trim();
                if (key === "email") value = value.toLowerCase();
                else value = value.toUpperCase();
            }

            acc[key] = value;
            return acc;
        }, {});
    };
    const handleActionClient = async (data) => {
        const normalizedData = normalizeData(data);
        if(!data?.id_client) {
            clientService.add(normalizedData,reset)
                .then((res) => {
                    setMessage("Cliente aggiunto con successo!");
                    setErrorMsg("");
                    onFetchClients(search);
                    reset();
                }).catch((error) => {
                    console.error("Error add client: ", error);
                    setMessage("");
                    setErrorMsg("Errore aggiunta cliente. Riprova.");
                }
            );
        } else {
            clientService.update(normalizedData,reset)
                .then((res) => {
                    setMessage("Cliente modificato con successo!");
                    setErrorMsg("");
                    onFetchClients(search);
                }).catch((error) => {
                    console.error("Error update client: ", error);
                    setMessage("");
                    setErrorMsg("Errore aggiornamento cliente. Riprova.");
                }
            );
        }
    }
    useEffect(() => {
        reset(client);
    }, [client, reset]);

  	return (
        <div className={`offcanvas offcanvas-end ${show ? "show" : ""}`}>
            <div className="offcanvas-header border-bottom">
                <h5 className="offcanvas-title">{client.id_client ? "Modifica " : "Aggiungi "} Cliente</h5>
                <button onClick={closeSlide} className="btn-close text-reset"></button>
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
                {errorMsg && <div className="mb-6 text-center alert alert-outline-danger">{errorMsg}</div>}
                {message && <div className="mb-6 text-center alert alert-outline-success">{message}</div>}
                <form className="add-new-user pt-0" onSubmit={handleSubmit(handleActionClient)}>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Nome Completo*</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.fullname ? "is-invalid" : ""}`}>
                                    <i className="bx bx-user" ></i>
                                </span>
                                <input type="text" className={`form-control ${errors.fullname ? "is-invalid" : ""}`}
                                    {...register('fullname', { required: 'Nome Completo richiesto' })}
                                />
                            </div>
                            {errors.fullname && <div className="invalid-input">{errors.fullname.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">P.IVA*</label>
                            <input className={`form-control ${errors.piva ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.piva ? errors.piva.message : ""}`}
                                {...register("piva", {
                                    required: "P.IVA richiesta!"
                                })}
                             />
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">SDI</label>
                            <input className={`form-control ${errors.identificativo ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.identificativo ? errors.identificativo.message : ""}`}
                                {...register("identificativo")}
                             />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Indirizzo sede*</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.indirizzo_sede ? "is-invalid" : ""}`}>
                                    <i className="bx bx-map" ></i>
                                </span>
                                <input type="text" className={`form-control ${errors.indirizzo_sede ? "is-invalid" : ""}`}
                                    {...register("indirizzo_sede", { required: 'Indirizzo sede richiesto' },
                                        {
                                            maxLength: {
                                                value: 200,
                                                message: "Limite massimo 200"
                                            }
                                        }
                                    )}
                                />
                            </div>
                            {errors.indirizzo_sede && <div className="invalid-input">{errors.indirizzo_sede.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Comune</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.comune ? "is-invalid" : ""}`}>
                                    <i className="bx bxs-city" ></i>
                                </span>
                                <input type="text" className={`form-control ${errors.comune ? "is-invalid" : ""}`}
                                    {...register("comune",
                                        {
                                            maxLength: {
                                                value: 200,
                                                message: "Limite massimo 200"
                                            }
                                        }
                                    )}
                                />
                            </div>
                            {errors.comune && <div className="invalid-input">{errors.comune.message}</div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Cap</label>
                            <input className={`form-control ${errors.cap ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.cap ? errors.cap.message : ""}`}
                                {...register("cap")}
                             />
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Provincia</label>
                            <input className={`form-control ${errors.provincia ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.provincia ? errors.provincia.message : ""}`}
                                {...register("provincia")}
                             />
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Nazione</label>
                            <input className={`form-control ${errors.nazione ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.nazione ? errors.nazione.message : ""}`}
                                {...register("nazione")}
                             />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Email</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.email ? "is-invalid" : ""}`}>
                                    <i className="bx bx-envelope" ></i>
                                </span>
                                <input type="text" className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                    {...register("email", {
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: "Email non valida!"
                                        }
                                    })}
                                />
                            </div>
                            {errors.email && <div className="invalid-input">{errors.email.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Pec</label>
                            <input className={`form-control ${errors.email_pec ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.email_pec ? errors.email_pec.message : ""}`}
                                {...register("email_pec")}
                             />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Iban</label>
                            <input className={`form-control ${errors.iban ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.iban ? errors.iban.message : ""}`}
                                {...register("iban")}
                             />
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Telefono</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.phone ? "is-invalid" : ""}`}>
                                    <i className="bx bx-phone" ></i>
                                </span>
                                <input type="text" className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                                    {...register("phone",
                                        {
                                            maxLength: {
                                                value: 25,
                                                message: "Limite massimo 25"
                                            }
                                        }
                                    )}
                                />
                            </div>
                            {errors.phone && <div className="invalid-input">{errors.phone.message}</div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Indirizzo consegna</label>
                            <input className={`form-control ${errors.indirizzo_consegna ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.indirizzo_consegna ? errors.indirizzo_consegna.message : ""}`}
                                {...register("indirizzo_consegna")}
                             />
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Stato</label>
                            <select className={`form-select ${errors.status ? "is-invalid" : ""}`}
                                type="text"  defaultValue="true"
                                placeholder={`${errors.status ? errors.status.message : ""}`}
                                {...register('status', { required: 'Seleziona uno stato' })}
                            >
                                <option value="true">Attivo</option>
                                <option value="false">Non Attivo</option>
                            </select>
                        </div>
                    </div>
                    <div className="col mb-6">
                        <label className="form-label">Note</label>
                        <textarea className="form-control" placeholder="Descrizione..."
                                {...register("note")}
                         />
                    </div>
                    <button type="submit" className="btn btn-primary me-3">Invia</button>
                    {!client.id_client && <button type="reset" className="btn btn-label-danger">Cancella</button>}
                </form>
            </div>
        </div>
	);
}